namespace Nobox.Common.Pages {
    export interface requestCampaignYear {
        Year?: string;
    }
}
